/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export class ElectricalSettingsActionNames {

    static GetElectricalSystemsInformation = (): string => '[Electrical Settings] GetElectricalInformation';
    static GetElectricalSystemsInformationSuccess = (): string => '[Electrical Settings] GetElectricalInformation success';

    static GetElectricalShortcutsModifiersInformation = (): string => '[Electrical Settings] GetElectricalModifiersInformation';
    static GetElectricalShortcutsModifiersInformationSuccess = (): string => '[Electrical Settings] GetElectricalModifiersInformation success';

    static GetInvalidShortcuts = (): string => '[Electrical Settings] GetInvalidShortcuts';
    static GetInvalidShortcutsSuccess = (): string => '[Electrical Settings] GetInvalidShortcuts success';

    static ApplyPreferences = (): string => '[Electrical Settings] ApplyPreferences';
    static ApplyPreferencesSuccess = (): string => '[Electrical Settings] ApplyPreferences success';
}